"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgShowerHighFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M26.54 9.49A16.67 16.67 0 0019 7.36V5a3 3 0 00-3-3H8a3 3 0 00-3 3v25h2V5a1 1 0 011-1h8a1 1 0 011 1v2.36a16.67 16.67 0 00-7.54 2.13L9 9.78V14h18V9.78z" }),
        React.createElement("circle", { cx: 12, cy: 17, r: 1 }),
        React.createElement("circle", { cx: 16, cy: 17, r: 1 }),
        React.createElement("circle", { cx: 20, cy: 17, r: 1 }),
        React.createElement("circle", { cx: 24, cy: 17, r: 1 }),
        React.createElement("circle", { cx: 12, cy: 21, r: 1 }),
        React.createElement("circle", { cx: 16, cy: 21, r: 1 }),
        React.createElement("circle", { cx: 20, cy: 21, r: 1 }),
        React.createElement("circle", { cx: 24, cy: 21, r: 1 }),
        React.createElement("circle", { cx: 12, cy: 25, r: 1 }),
        React.createElement("circle", { cx: 16, cy: 25, r: 1 }),
        React.createElement("circle", { cx: 20, cy: 25, r: 1 }),
        React.createElement("circle", { cx: 24, cy: 25, r: 1 }),
        React.createElement("circle", { cx: 12, cy: 29, r: 1 }),
        React.createElement("circle", { cx: 16, cy: 29, r: 1 }),
        React.createElement("circle", { cx: 20, cy: 29, r: 1 }),
        React.createElement("circle", { cx: 24, cy: 29, r: 1 })));
}
exports.default = SvgShowerHighFilled;
//# sourceMappingURL=ShowerHighFilled.js.map